import apiDB from './api_db';

let modules = new apiDB({
    api_module: 'module',
    table_key_name: 'module_id',
    reducer_name: 'moduleR',
    reducer_var: 'module',
    action_prefix: 'MODULE'});

export default modules;